import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledPageShell = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${tokens.colors.background};
`;

export function PageShell({ children, ...props }) {
  return <StyledPageShell {...props}>{children}</StyledPageShell>;
}

export default PageShell;
